import EmailIcon from '@mui/icons-material/Email';
import PhoneIcon from '@mui/icons-material/Phone';
import PhoneIphoneIcon from '@mui/icons-material/PhoneIphone';
import PrintIcon from '@mui/icons-material/Print';
import React from 'react';

import { Contact, ST } from '_lib/api/apiTypes.shim';

import { Chip } from '_lib/components/Chip/Chip';
import { formatPhone } from '_lib/utils/helpers';

export interface ReadOnlyContactProps {
  contact: Contact;
  onEditContact?: (contact: Contact) => void;
  onDeleteContact?: (contact: Contact) => void;
  isDisabled?: boolean;
}

const iconMap = {
  Email: <EmailIcon fontSize='small' />,
  Fax: <PrintIcon fontSize='small' />,
  MobilePhone: <PhoneIphoneIcon fontSize='small' />,
  Phone: <PhoneIcon fontSize='small' />
};

export const ReadOnlyContact = (props: ReadOnlyContactProps): React.ReactElement => {
  const { contact, isDisabled, onDeleteContact, onEditContact } = props;

  return (
    <Chip
      data-testid={`ro-contact-${contact.providerId}`}
      onClick={onEditContact ? () => onEditContact(contact) : undefined}
      onDelete={onDeleteContact ? () => onDeleteContact(contact) : undefined}
      size='medium'
      icon={iconMap[contact.type]}
      label={contact.type === ST.ContactTypeEnum.Email ? contact.value : formatPhone(contact.value)}
      disabled={isDisabled}
      key={`ro-contact-${contact.providerId}`}
      sx={{
        margin: 0.5
      }}
    />
  );
};
